import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import * as optionGroupsActions from '../../actions/components/optionGroups'
import OptionGroups from '../../components/OptionGroups'
import injectSheet from 'react-jss'
import styles from '../../assets/styles/components/OptionGroups'

const mapStateToProps = (state) => {
  const stash = state.stash
  const stashByOptionGroups = state.stashByOptionGroups
  const stashByRadioGroups = state.stashByRadioGroups
  return {
    stash,
    stashByOptionGroups,
    stashByRadioGroups,
  }
}
const mapDispatchToProps = (dispatch) => {
  const {
    addStashByOptionGroups,
    removeStashByOptionGroups,
    addStashByRadioGroups,
  } = bindActionCreators(optionGroupsActions, dispatch)

  return {
    addStashByOptionGroups,
    removeStashByOptionGroups,
    addStashByRadioGroups,
  }
}

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectSheet(styles)(OptionGroups)))



// WEBPACK FOOTER //
// ./src/containers/components/OptionGroups.js